// extracted by mini-css-extract-plugin
export default {"contentLog":"usTe_contentLog__YemmR","formLog":"usTe_formLog__CThLX"};